// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__vBegK","tri":"Loading_tri__9qnTb"};